<template>
  <div class="jin-welfare">
    <img class="top-ball-icon" src="~@/assets/index/welfare/球-元素@2x.png" alt="">
    <img class="bottom-ball-icon" src="~@/assets/index/welfare/球-元素-2@2x.png" alt="">
    <div class="jin-welfare-title srcoll-el">薪酬福利</div>
    <div class="jin-welfare-title-en">Compensation and Benefits</div>
    <div class="jin-welfare-content">
      <van-swipe :loop="false" :show-indicators="false" :width="322">
        <van-swipe-item v-for="(item,index) in welfareList" :key="index" class="jin-welfare-content-item">
          <img v-lazy="item.img" alt="">
          <div class="title-wrap">
            <div class="title">{{ item.title }}</div>
            <div class="des">{{ item.des }}</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { welfareList } from '@/views/index/page/option.js'

export default {
  data() {
    return {
      welfareList
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-welfare {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding:54px 0;
    background: #fff;
    overflow: hidden;
    div {
      box-sizing: border-box;
    }
    .top-ball-icon {
      position: absolute;
      left: 203px;
      top: 0;
      width: 92px;
    }
    .bottom-ball-icon {
      position: absolute;
      left: 0;
      bottom: 25px;
      width: 46px;
    }
    .jin-welfare-title {
      height: 27px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3D4351;
      line-height: 27px;
      text-align: center;
    }
    .jin-welfare-title-en {
      height: 16px;
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787B8A;
      line-height: 16px;
      text-align: center;
      margin-bottom: 18px;
    }
    .jin-welfare-content {
      width: 100%;
      margin: 0 18px;
    //   margin: 0 auto;
      .jin-welfare-content-item {
        width: 313px!important;
        height: 255px;
        margin: 0 9px 6px 0;
        background: #FFFFFF;
        box-shadow: 0 0 9px 0 rgba(0,0,0,0.08);
        // border-radius: 9px;
        overflow: hidden;
        // &:last-child {
        //     margin-right: 0;
        // }
        img {
          width: 100%;
          height: 180px;
        }
    .title-wrap {
        width: 100%;
        // height: 100%;
        padding: 13px 15px 16px 18px;
            .title {
            height: 21px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3D4351;
            line-height: 21px;
            margin-bottom: 5px;
        }
        .des {
          height: 16px;
          font-size: 11px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          color: #787B8A;
          line-height: 16px;
        }
    }
      }
    }
}
</style>
